import type { PageableContent, UserInterface } from '@/types'
import api from '@/utils/api/api'

import type { UpdateUserRequest, UsersPageParams } from '../types/users.types'

type RequestOptions = {
  signal?: AbortSignal
}

type UsersListResponse = { users: PageableContent<UserInterface> }

const USERS_PATH = '/users'

export const usersApi = {
  getUsers: async (params: UsersPageParams, options?: RequestOptions) => {
    const { data } = await api.get<UsersListResponse>(USERS_PATH, {
      params,
      signal: options?.signal,
    })
    return data.users
  },
  updateUser: async (id: string, payload: UpdateUserRequest) => {
    await api.put(`${USERS_PATH}/${id}`, payload, { _skipSanitize: true })
  },
}
